import { render, staticRenderFns } from "./questionDialog.vue?vue&type=template&id=6386fb7e&scoped=true&"
import script from "./questionDialog.vue?vue&type=script&lang=js&"
export * from "./questionDialog.vue?vue&type=script&lang=js&"
import style0 from "./questionDialog.vue?vue&type=style&index=0&id=6386fb7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6386fb7e",
  null
  
)

export default component.exports